export default __webpack_public_path__ + "src/images/packages/emily-moon-lodge/7609ee2400fa6c9e3ba96dfa74ce1200-5.jpg";